import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppShell } from '../components/AppShell.jsx';
import { SidebarHelp, SidebarLink } from '../components/SidebarNav.jsx';
import { UserMenu } from '../components/UserMenu.jsx';
import { OnboardingHelpButton } from '../onboarding/OnboardingProvider.jsx';

export function SuperAdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AppShell
      brandFallback={{ name: 'Agency360' }}
      subtitle="SaaS Admin Portal"
      searchPlaceholder="Search organizations, users, or anything…"
      onSearch={(term) => {
        const q = encodeURIComponent(term);
        if (location.pathname.startsWith('/super-admin/users')) {
          navigate(`/super-admin/users?search=${q}`);
          return;
        }
        if (location.pathname.startsWith('/super-admin/clients')) {
          navigate(`/super-admin/clients?search=${q}`);
          return;
        }
        navigate(`/super-admin/organizations?search=${q}`);
      }}
      nav={
        <>
          <SidebarLink to="/super-admin" label="Dashboard" end icon="home" tourId="tour-nav-dashboard" />
          <SidebarLink to="/super-admin/organizations" label="Organizations" icon="directory" tourId="tour-nav-directory" />
          <SidebarLink to="/super-admin/users" label="Users" icon="clients" />
          <SidebarLink to="/super-admin/clients" label="Clients" icon="clients" />
          <SidebarLink to="/super-admin/plans" label="Subscription Plans" icon="plans" tourId="tour-nav-plans" />
        </>
      }
      topbar={
        <div className="topbar-utilities" data-tour="tour-utilities">
          <OnboardingHelpButton />
          <UserMenu profileTo="/super-admin/profile" roleLabel="Super Administrator" />
        </div>
      }
      footer={<SidebarHelp href="mailto:support@viib.ca" />}
    >
      <Outlet />
    </AppShell>
  );
}
